import { Switch, Redirect } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';

import ClientAccountPage from './ClientAccountPage/ClientAccountPage';
import TransferFund from './TransferFund/TransferFundContainer';
import TransferDetails from './TransferFund/Details/TransferDetails';
import FundTransferDetails from './TransferFund/Details/FundTransferDetails';
import WithdrawTransferDetails from './TransferFund/Details/WithdrawTransferDetails';
import FundWithdrawTransferDetails from './TransferFund/Details/FundWithdrawTransferDetails';
import ScheduledTransactionsContainer from './ClientAccountSchedule/ScheduledTransactionsContainer';
import ScheduledTransactionDetailsContainer from './ClientAccountSchedule/Details/ScheduledTransactionDetailsContainer';
import ClientAccountsPage from './ClientAccountsPage/ClientAccountsPage';
import CreateClientAccountPage from './CreateClientAccount/CreateClientAccountPage';

import { JSX } from 'react';

const Routes = (): JSX.Element => {
  const featureFlags = useModuleFeatureFlag('clientAccounts');

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.AddClientAccount}
        showPermission
        path="/client-accounts/create"
        exact
        component={CreateClientAccountPage}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewClientAccounts}
        showPermission
        path="/client-accounts/:accountID"
        exact
        component={ClientAccountPage}
      />

      {/* Orphan copy with the new flow's embedded Receivables/Payables tabs — URL only, no menu entry (ID-13335) */}
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewClientAccounts}
        showPermission
        path="/accounting/client-accounts/:accountID"
        exact
      >
        <ClientAccountPage accountingEnabled />
      </ProtectedRoute>

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewClientAccounts}
        showPermission
        path="/client-accounts"
        exact
        component={ClientAccountsPage}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewClientAccounts}
        showPermission
        path="/client-accounts-list/details/:AccountID"
        exact
        render={({ match }) => {
          return <Redirect to={`/client-accounts/${match.params.AccountID}`} />;
        }}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewClientAccounts}
        showPermission
        path="/client-accounts-list"
        exact
        component={() => {
          return <Redirect to="/client-accounts" />;
        }}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.AddClientAccount}
        showPermission
        path="/add-client-account"
        exact
        component={() => {
          return <Redirect to="/client-accounts/create" />;
        }}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.CreateClientAccountTransfers}
        showPermission
        path="/client-account-transfer-funds"
        exact
        component={TransferFund}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.CreateClientAccountTransfers}
        showPermission
        path="/client-account-transfer-funds/details/transfer"
        exact
        component={TransferDetails}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.CreateClientAccountTransfers}
        showPermission
        path="/client-account-transfer-funds/details/fund-transfer"
        exact
        component={FundTransferDetails}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.CreateClientAccountTransfers}
        showPermission
        path="/client-account-transfer-funds/details/withdraw-transfer"
        exact
        component={WithdrawTransferDetails}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.CreateClientAccountTransfers}
        showPermission
        path="/client-account-transfer-funds/details/fund-withdraw-transfer"
        exact
        component={FundWithdrawTransferDetails}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.CreateClientAccountTransfers}
        showPermission
        path="/client-account-schedule"
        exact
        component={ScheduledTransactionsContainer}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.CreateClientAccountTransfers}
        showPermission
        path="/client-account-schedule/details/:TransferID"
        exact
        component={ScheduledTransactionDetailsContainer}
      />
    </Switch>
  );
};

export default Routes;
